package com.ijoin.data.model

import kotlinx.serialization.Serializable
import kotlin.math.max

/**
 * Platform fee settings for calculating service fees.
 */
@Serializable
data class PlatformFee(
    val enabled: Boolean = true,
    val feePercent: Double = 0.05,
    val minFeeAmount: Double = 0.50
) {
    /**
     * Calculate fee for a given ticket price.
     */
    fun calculateFee(ticketPrice: Double): Double {
        if (!enabled || ticketPrice <= 0) return 0.0
        val calculatedFee = ticketPrice * feePercent
        return max(calculatedFee, minFeeAmount)
    }

    /**
     * Calculate total amount (ticket price + fee).
     */
    fun calculateTotal(ticketPrice: Double): Double {
        return ticketPrice + calculateFee(ticketPrice)
    }

    /**
     * Get fee percentage as display string (e.g., "5%").
     */
    fun feePercentDisplay(): String {
        return "${(feePercent * 100).toInt()}%"
    }

    companion object {
        val DEFAULT = PlatformFee()
        val DISABLED = PlatformFee(enabled = false)
    }
}
